import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID (replace with your actual ID)
export const initGA = (measurementId: string) => {
  ReactGA.initialize(measurementId);
};

// Track page views
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Track events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track user timing
export const trackTiming = (category: string, variable: string, value: number, label?: string) => {
  ReactGA.event({
    category,
    action: variable,
    label,
    value,
  });
};

// Track exceptions
export const trackException = (description: string, fatal: boolean = false) => {
  ReactGA.event({
    category: 'exception',
    action: description,
    label: fatal ? 'fatal' : 'non-fatal',
  });
};

// Set user ID
export const setUserId = (userId: string) => {
  ReactGA.set({ userId });
};

// Add custom dimensions
export const setCustomDimension = (dimensionIndex: number, value: string) => {
  ReactGA.set({ [`dimension${dimensionIndex}`]: value });
}; 